/* eslint-disable import/prefer-default-export */
export const licensingURL = '/selfservice/article-licensing';
export const licensingContactEmail = 'articlelicensing@industrydive.com';
